import styled from '@emotion/styled'
import Box from '@mui/material/Box'
import { clean } from 'utils/clean-url'
import Link from 'components/common/A'

const LinkWrapper = styled(Box)`
  ${({ theme, $isFirst }) => `
  margin-top: ${$isFirst ? 0 : theme.spacing(3)};

  & > a,
  & > span {
    color: ${theme.palette.text.minus2};
  }
`}
`

const LinkItem = ({ href, children, $isFirst, onClick, ...rest }) => {
  const cleanedHref = clean(href)

  // 有 href：渲染真正的 next/link 連結，行為不變
  if (cleanedHref) {
    return (
      <LinkWrapper $isFirst={$isFirst}>
        <Link href={cleanedHref} $origin {...rest} onClick={onClick}>
          {children}
        </Link>
      </LinkWrapper>
    )
  }

  // 無 href：渲染非 anchor 的 <span>（不帶 href），避免 hover 時瀏覽器狀態列
  // 浮現由 next/link 空字串 href 相對當前 route 解析出的網址。
  const { style } = rest
  const isClickable = !!onClick

  // 因 Link 改為 span，故考量 a11y
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onClick(event)
    }
  }

  return (
    <LinkWrapper $isFirst={$isFirst}>
      <Box
        component="span"
        role={isClickable ? 'button' : undefined}
        tabIndex={isClickable ? 0 : undefined}
        onClick={onClick}
        onKeyDown={isClickable ? handleKeyDown : undefined}
        style={{ cursor: isClickable ? 'pointer' : 'default', ...style }}
      >
        {children}
      </Box>
    </LinkWrapper>
  )
}

export default LinkItem
